/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var _excluded = ["children"];

/**
 * `ListBoxMenu` is a simple container node that isolates the `list-box__menu`
 * class into a single component. It is also being used to validate given
 * `children` components.
 */
var ListBoxMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({
      className: "cds--list-box__menu",
      ref: ref
    }, rest), children)
  );
});
ListBoxMenu.propTypes = {
  children: PropTypes.node
};
ListBoxMenu.defaultProps = {
  children: undefined
};
var ListBoxMenu$1 = ListBoxMenu;

export { ListBoxMenu$1 as default };
